import { IconCheckGreenSmall } from "@repo/assets/images";
import { CurrencySymbol } from "@repo/components";
import cx from "classnames";
const ShippingTag = ({
  shippingFee,
  cartRule,
  t
}) => {
  const isShippingFree = shippingFee === 0;
  return <div className="border-supportiveDarkGray mt-4 border-b pb-4 md:mx-4" data-sentry-component="ShippingTag" data-sentry-source-file="ShippingTag.jsx">
      <div className={cx("border px-4 py-3 text-sm", {
      "border-darkgreen bg-lightgreen": isShippingFree,
      "border-supportiveDarkGray bg-supportiveThinGray": !isShippingFree
    })}>
        <p className={cx("font-medium", {
        flex: isShippingFree
      })}>
          <span>{t("Free_Shipping")}</span>
          {isShippingFree && <span className="text-mediumgreen ms-auto flex items-center">
              <IconCheckGreenSmall className="me-1" />
              {t("Applied")}
            </span>}
        </p>

        <p className={cx("flex items-center space-x-1 pt-1 text-[#79747E] rtl:space-x-1", {
        hidden: isShippingFree
      })}>
          <span>{t("Free_Shipping_For_Orders_Over")}</span>
          <CurrencySymbol value={cartRule?.minAmount} variant="smallSpecial" data-sentry-element="CurrencySymbol" data-sentry-source-file="ShippingTag.jsx" />
        </p>
      </div>
    </div>;
};
export default ShippingTag;